import script from "./AuthorizationReview.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthorizationReview.vue?vue&type=script&setup=true&lang=js"

import "./AuthorizationReview.vue?vue&type=style&index=0&id=d6ca86c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6ca86c4"]])

export default __exports__